import service from "@irati/utils/tracking/index"
import {Tag, Deal, Team} from "@irati/types"

const tracking = {
  changeTagVisibility: (tag: Tag, newValue: string) => {
    const data = {
      tag_id: tag.uuid,
      tag_new_value: newValue,
      tag_name: tag.name
    }
    service.trackEvent("admin_change_perks_tag_visibility", data)
  },

  changePerkVisibility: (perk: Deal, newValue: string) => {
    const data = {
      perk_id: perk.uuid,
      perk_new_value: newValue,
      perk_name: perk.header
    }
    service.trackEvent("admin_change_perk_visibility", data)
  },

  createTeam: (teamName: string) => {
    const data = {team_name: teamName}
    service.trackEvent("admin_create_team", data)
  },

  startCreateUser: (createType: string) => {
    switch (createType) {
      case "add_people-single":
        service.trackEvent("admin_start_create_user")
        break
      case "add_people-multiple":
        service.trackEvent("admin_start_create_users")
        break
      default:
        return null
    }
  },

  createUser: (access: string, teams: [Team]) => {
    const data = {
      access_level: access,
      team: teams
    }
    service.trackEvent("admin_create_user", data)
  },

  createUsers: () => {
    service.trackEvent("admin_create_users")
  },

  startEnableSSO: () => {
    service.trackEvent("admin_start_enable_sso")
  },

  enableSSO: () => {
    service.trackEvent("admin_enable_sso")
  },

  enableSSU: () => {
    service.trackEvent("admin_enable_ssu")
  },

  updateWelcomeEmail: () => {
    service.trackEvent("admin_update_welcome_email")
  },

  updateLogo: () => {
    service.trackEvent("admin_update_logo")
  },

  updateColorScheme: () => {
    service.trackEvent("admin_update_colour_scheme")
  },

  downloadRewardLog: () => {
    service.trackEvent("admin_download_rewards")
  },

  editUserExternalID: (userId: string) => {
    const data = {
      userId
    }
    service.trackEvent("admin_edit_external_id", data)
  },

  viewHelp: () => {
    service.trackEvent("admin_view_help")
  },

  viewTrainingWebinars: () => {
    service.trackEvent("admin_view_training_webinars")
  },

  viewLaunchingPerkbox: () => {
    service.trackEvent("admin_view_launching_perkbox")
  },

  viewCustomisation: () => {
    service.trackEvent("admin_view_customisation")
  },

  viewPeopleManagement: () => {
    service.trackEvent("admin_view_people_management")
  },

  viewBillingPayments: () => {
    service.trackEvent("admin_view_billing_payments")
  },

  addRegions: () => {
    service.trackEvent("admin_regions_addRegions")
  },

  viewRegions: () => {
    service.trackEvent("admin_regions_view")
  },

  assignTeams: () => {
    service.trackEvent("admin_people_multiselect_assignTeams")
  },

  assignTeamsConfirmed: () => {
    service.trackEvent("admin_people_multiselect_assignTeams_confirmed")
  },

  assignTeamsSetPrimaryTeam: () => {
    service.trackEvent("admin_people_multiselect_assignTeams_setPrimaryteam")
  },

  assignTeamsSetOtherTeam: () => {
    service.trackEvent("admin_people_multiselect_assignTeams_setOtherteam")
  },

  deativate: () => {
    service.trackEvent("admin_people_multiselect_deactivate")
  },

  deactivateConfirmed: () => {
    service.trackEvent("admin_people_multiselect_deactivate_confirmed")
  },

  searchPeople: () => {
    service.trackEvent("admin_people_searchPeople")
  },

  filterRegion: () => {
    service.trackEvent("admin_people_filterRegion")
  },

  filterStatusRole: () => {
    service.trackEvent("admin_people_filterStatusRole")
  },

  filterSortBy: () => {
    service.trackEvent("admin_people_sortBy")
  },

  viewUser: () => {
    service.trackEvent("admin_people_viewsUser")
  },

  editsRegion: () => {
    service.trackEvent("admin_people_viewsUser_editsRegion")
  },

  editsRole: () => {
    service.trackEvent("admin_people_viewsUser_editsRole")
  },

  editsTeam: () => {
    service.trackEvent("admin_people_viewsUser_editsTeam")
  },

  deactivatesUser: () => {
    service.trackEvent("admin_people_viewsUser_deactivates")
  },

  resetPassword: () => {
    service.trackEvent("admin_people_viewsUser_resetPassword")
  },

  reactivatesUser: () => {
    service.trackEvent("admin_people_viewsUser_reactivates")
  },

  companyBenefitsAdd: () => {
    service.trackEvent("admin_settings_addCompanyBenefits")
  },

  companyBenefitsSelectAudience: () => {
    service.trackEvent("admin_settings_addCompanyBenefits_selectAudience")
  },

  companyBenefitsCreateTitle: () => {
    service.trackEvent("admin_settings_addCompanyBenefits_createsTitle")
  },

  companyBenefitsAddDescription: () => {
    service.trackEvent("admin_settings_addCompanyBenefits_addsDescription")
  },

  companyBenefitsWritesInstructions: () => {
    service.trackEvent("admin_settings_addCompanyBenefits_writesInstructions")
  },

  setPrimaryTeam: () => {
    service.trackEvent("admin_people_viewsUser_setPrimaryTeam")
  },

  userExport: () => {
    service.trackEvent("admin_user_export")
  },

  analyticsOverall: () => {
    service.trackEvent("admin_analytics_overall")
  },

  analyticsPeople: () => {
    service.trackEvent("admin_analytics_people")
  },

  analyticsTeams: () => {
    service.trackEvent("admin_analytics_teams")
  },

  analyticsContent: () => {
    service.trackEvent("admin_analytics_content")
  },

  analyticsClickFilterIndustry: () => {
    service.trackEvent("admin_analytics_externalBenchmarking_filterIndustry")
  },

  analyticsClickBottomLeftQuadrant: () => {
    service.trackEvent("admin_analytics_teams_quadrant3BottomLeft")
  },

  analyticsClickTopLeftQuadrant: () => {
    service.trackEvent("admin_analytics_teams_quadrant1TopLeft")
  },

  analyticsClickBottomRightQuadrant: () => {
    service.trackEvent("admin_analytics_teams_quadrant4BottomRight")
  },

  analyticsClickTopRightQuadrant: () => {
    service.trackEvent("admin_analytics_teams_quadrant2TopRight")
  },

  analyticsClickBreadownEditTeams: () => {
    service.trackEvent("admin_analytics_breadownEditTeams")
  },

  analyticsSetDefaultBenchmark: () => {
    service.trackEvent("admin_analytics_overall_setDefaultBenchmark")
  },

  analyticsChangeDefaultBenchmark: () => {
    service.trackEvent("admin_analytics_overall_changeDefaultBenchmark")
  },

  analyticsSetTimeRange: () => {
    service.trackEvent("admin_analytics_teams_setTimeRangeScatterGraph")
  },
  bulkAssignManagers: () => {
    service.trackEvent("admin_teams_bulkAssignManagers_start")
  },
  bulkAssignManagersSuccessful: () => {
    service.trackEvent("admin_teams_bulkAssignManagers_successful")
  },
  filterPerkRedemptionsRegions: () => {
    service.trackEvent("admin_teams_regions_filterPerkRedemptions")
  },
  filterPerkRedemptionsTeams: () => {
    service.trackEvent("admin_teams_teams_filterPerkRedemptions")
  },
  updateRegionsFilter: () => {
    service.trackEvent("admin_analytics_teams_addRegionsFilter")
  },
  filterMostPopularPerks: () => {
    service.trackEvent("admin_interests_filterMostPopularPerks")
  },
  globalModalAddCountries: () => {
    service.trackEvent("admin_globalModal_addCountries")
  },
  globalModalWhatIsThis: () => {
    service.trackEvent("admin_globalModal_whatIsThis")
  },
  globalModalWhatIsThisNotRelevant: () => {
    service.trackEvent("admin_globalModal_whatisThis_notRelevant")
  },
  globalModalWhatIsThisAddCountries: () => {
    service.trackEvent("admin_globalModal_whatisThis_addCountries")
  },
  globalModalClose: () => {
    service.trackEvent("admin_globalModal_close")
  },
  globalModalNotRelevantConfirm: () => {
    service.trackEvent("admin_globalModal_whatisThis_notRelevant_confirm")
  },
  navigationClickHome: () => {
    service.trackEvent("admin_navTabv2_home")
  },
  navigationClickPeople: () => {
    service.trackEvent("admin_navTabv2_people")
  },
  navigationClickTeams: () => {
    service.trackEvent("admin_navTabv2_teams")
  },
  navigationClickCountries: () => {
    service.trackEvent("admin_navTabv2_countries")
  },
  navigationClickReporting: () => {
    service.trackEvent("admin_navTabv2_reporting")
  },
  navigationClickReportingCompany: () => {
    service.trackEvent("admin_navTabv2_reporting_company")
  },
  navigationClickReportingGroups: () => {
    service.trackEvent("admin_navTabv2_reporting_groups")
  },
  navigationClickReportingIndividuals: () => {
    service.trackEvent("admin_navTabv2_reporting_individuals")
  },
  navigationClickReportingInterests: () => {
    service.trackEvent("admin_navTabv2_reporting_interests")
  },
  navigationClickCustomisations: () => {
    service.trackEvent("admin_navTabv2_customisations")
  },
  navigationClickCustomisationsLogo: () => {
    service.trackEvent("admin_navTabv2_customisations­_logo")
  },
  navigationClickCustomisationsPerkVisibility: () => {
    service.trackEvent("admin_navTabv2_customisations­_perkVisibility")
  },
  navigationClickCustomisationsCustomBenefits: () => {
    service.trackEvent("admin_navTabv2_customisations­_customBenefits")
  },
  navigationClickCustomisationsCompanyValues: () => {
    service.trackEvent("admin_navTabv2_customisations­_companyValues")
  },
  navigationClickCustomisationsCompanyCelebrations: () => {
    service.trackEvent("admin_navTabv2_customisations­_companyCelebrations")
  },
  navigationClickIntegrations: () => {
    service.trackEvent("admin_navTabv2_integrations")
  },
  navigationClickSettings: () => {
    service.trackEvent("admin_navTabv2_settings")
  },
  navigationClickSettingsSelfSignup: () => {
    service.trackEvent("admin_navTabv2_settings_selfSignup")
  },
  navigationClickSettingsRolePermissions: () => {
    service.trackEvent("admin_navTabv2_settings_rolePermissions")
  },
  navigationClickHelp: () => {
    service.trackEvent("admin_navTabv2_help")
  },
  navigationClickRewards: () => {
    service.trackEvent("admin_navTabv2_rewardWallet")
  },
  navigationClickRewardsNew: () => {
    service.trackEvent("admin_click_reward_nav")
  },
  navigationExpandCollapseMenu: () => {
    service.trackEvent("admin_navTabv2_menuExpandCollapse")
  },
  submitGlobalModalReasons: (reasons: string[]) => {
    service.trackEvent("admin_globalModal_close_submitReasons", {reasons})
  },
  adminHeaderClickBackwardsForwardsButton: () => {
    service.trackEvent("admin_click_backwardsFowards_buttons")
  },
  adminHeaderClickBreadcrumbs: () => {
    service.trackEvent("admin_click_breadcrumbs")
  },
  adminHeaderClickAdminHub: () => {
    service.trackEvent("admin_click_adminHub")
  },
  adminNavMainMenuExpanseCollapse: () => {
    service.trackEvent("admin_navTabv2_mainMenuExpandCollapse")
  },
  adminNavSubMenuExpanseCollapse: () => {
    service.trackEvent("admin_navTabv2_subMenuExpandCollapse")
  },
  triggerWorkOSIntegrationsSSO: () => {
    service.trackEvent("admin_settings_integrations_sso_shortcutLink_start")
  },
  triggerWorkOSIntegrationsDsync: () => {
    service.trackEvent("admin_settings_integrations_dsync_shortcutLink_start")
  },
  copyLinkWorkOSIntegrationsSSO: () => {
    service.trackEvent("admin_settings_integrations_sso_shortcutLink_linkCopied")
  },
  copyLinkWorkOSIntegrationsDsync: () => {
    service.trackEvent("admin_settings_integrations_dsync_shortcutLink_linkCopied")
  },
  adminPeopleAddCountry: (source: string) => {
    service.trackEvent("admin_people_countryDropdown_selectAddCountry", {source})
  },
  adminPeopleConfirmAddCountry: (source: string) => {
    service.trackEvent("admin_people_countryDropdown_confirmAddCountry", {source})
  },
  unusedLicensesClick: () => {
    service.trackEvent("admin_people_unusedLicenses_clickAddUsers")
  },
  analyticsTopPerksSetDate: () => {
    service.trackEvent("admin_analytics_top_perk_setDate")
  },
  analyticsTopPerksSetCountry: () => {
    service.trackEvent("admin_analytics_top_perk_setCountry")
  },
  analyticsTopPerksSetTeam: () => {
    service.trackEvent("admin_analytics_top_perk_setTeam")
  },
  analyticsTopPerksDownloadReport: () => {
    service.trackEvent("admin_analytics_top_perk_downloadReport")
  },
  analyticsTopPerksClickSeeAll: () => {
    service.trackEvent("admin_analytics_top_perk_seeAll")
  },
  analyticsEngagementClickFilter: () => {
    service.trackEvent("admin_analytics_engagement_setFilter")
  },
  analyticsEngagementClickAllFilter: () => {
    service.trackEvent("admin_analytics_engagement_all_filter")
  },
  analyticsEngagementClickPerkFilter: () => {
    service.trackEvent("admin_analytics_engagement_perk_filter")
  },
  analyticsEngagementClickFlexiPerkFilter: () => {
    service.trackEvent("admin_analytics_engagement_flexi_perk_filter")
  },
  analyticsEngagementClickCelebrationsFilter: () => {
    service.trackEvent("admin_analytics_engagement_celebrations_filter")
  },
  analyticsEngagementClickWellnessFilter: () => {
    service.trackEvent("admin_analytics_engagement_wellness_filter")
  },
  analyticsEngagementSetCurrency: () => {
    service.trackEvent("admin_analytics_engagement_currency_filter")
  },
  analyticsEngagementSetDate: () => {
    service.trackEvent("admin_analytics_engagement_setDate")
  },
  analyticsEngagementSetCountry: () => {
    service.trackEvent(" admin_analytics_engagement_setCountry")
  },
  analyticsEngagementSetTeam: () => {
    service.trackEvent(" admin_analytics_engagement_setTeam")
  },
  analyticsEngagementDownloadReport: () => {
    service.trackEvent("admin_analytics_engagement_download")
  },
  clickDeleteCountryIcon: () => {
    service.trackEvent("admin_countries_deleteCountry_start")
  },
  clickConfirmDelete: () => {
    service.trackEvent("admin_countries_deleteCountry_confirm")
  },
  submitDeleteCountryReasons: (reasons: string[]) => {
    service.trackEvent("admin_countries_deleteCountry", {reasons})
  }
}

export default tracking
